/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ObjectBaseResponse } from '../models/object-base-response';
import { StringBaseResponse } from '../models/string-base-response';

@Injectable({
  providedIn: 'root',
})
export class DatabaseCopyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiDatabaseCopyHealthGet
   */
  static readonly ApiDatabaseCopyHealthGetPath = '/api/DatabaseCopy/health';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDatabaseCopyHealthGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyHealthGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ObjectBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DatabaseCopyService.ApiDatabaseCopyHealthGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ObjectBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDatabaseCopyHealthGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyHealthGet$Plain(params?: {
  }): Observable<ObjectBaseResponse> {

    return this.apiDatabaseCopyHealthGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ObjectBaseResponse>) => r.body as ObjectBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDatabaseCopyHealthGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyHealthGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ObjectBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DatabaseCopyService.ApiDatabaseCopyHealthGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ObjectBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDatabaseCopyHealthGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyHealthGet$Json(params?: {
  }): Observable<ObjectBaseResponse> {

    return this.apiDatabaseCopyHealthGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ObjectBaseResponse>) => r.body as ObjectBaseResponse)
    );
  }

  /**
   * Path part for operation apiDatabaseCopyCopyPost
   */
  static readonly ApiDatabaseCopyCopyPostPath = '/api/DatabaseCopy/copy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDatabaseCopyCopyPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyCopyPost$Plain$Response(params?: {
    includeDlmDb?: boolean;
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DatabaseCopyService.ApiDatabaseCopyCopyPostPath, 'post');
    if (params) {
      rb.query('includeDlmDb', params.includeDlmDb, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDatabaseCopyCopyPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyCopyPost$Plain(params?: {
    includeDlmDb?: boolean;
  }): Observable<StringBaseResponse> {

    return this.apiDatabaseCopyCopyPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDatabaseCopyCopyPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyCopyPost$Json$Response(params?: {
    includeDlmDb?: boolean;
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DatabaseCopyService.ApiDatabaseCopyCopyPostPath, 'post');
    if (params) {
      rb.query('includeDlmDb', params.includeDlmDb, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDatabaseCopyCopyPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDatabaseCopyCopyPost$Json(params?: {
    includeDlmDb?: boolean;
  }): Observable<StringBaseResponse> {

    return this.apiDatabaseCopyCopyPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

}
